import { AiCritical, AiWarn, AiTransferred } from '@frontend/styled-icons';
import {
  AiSuccessWithTooltip,
  AiWarnWithTooltip,
  AiCriticalWithTooltip,
  AiSuccess,
  AiTransferredWithTooltip,
  AiQuestion,
  AiQuestionWithTooltip,
} from './ai';

export const OUTCOME_MAPPING = {
  SUCCESS: 'success',
  ROUTE_ANSWERED: 'route_answered',
  ROUTE_MISSED: 'route_missed',
  FATAL: 'fatal',
  TEXT_HANDOFF: 'text_handoff',
  INCOMPLETE: 'incomplete',
} as const;

export type OutcomeType = (typeof OUTCOME_MAPPING)[keyof typeof OUTCOME_MAPPING];

export const getAiOutcomeIcon = ({ outcome }: { outcome: OutcomeType }) => {
  switch (outcome) {
    case OUTCOME_MAPPING.SUCCESS:
      return <AiSuccess />;
    case OUTCOME_MAPPING.ROUTE_ANSWERED:
      return <AiTransferred />;
    case OUTCOME_MAPPING.ROUTE_MISSED:
      return <AiWarn />;
    case OUTCOME_MAPPING.FATAL:
      return <AiCritical />;
    case OUTCOME_MAPPING.TEXT_HANDOFF:
      return <AiTransferred />;
    case OUTCOME_MAPPING.INCOMPLETE:
      return <AiQuestion />;
    default:
      return null;
  }
};

export const getAiOutcomeIconWithTooltip = ({ outcome, tooltip }: { outcome: OutcomeType; tooltip?: string }) => {
  switch (outcome) {
    case OUTCOME_MAPPING.SUCCESS:
      return <AiSuccessWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.ROUTE_ANSWERED:
      return <AiTransferredWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.ROUTE_MISSED:
      return <AiWarnWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.FATAL:
      return <AiCriticalWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.TEXT_HANDOFF:
      return <AiTransferredWithTooltip tooltipText={tooltip} />;
    case OUTCOME_MAPPING.INCOMPLETE:
      return <AiQuestionWithTooltip tooltipText={tooltip} />;
    default:
      return null;
  }
};
